import React, { useState } from 'react';
import { useI18n } from '../i18n/LanguageContext';

export default function Newsletter() {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await new Promise((r) => setTimeout(r, 400));
      setEmail('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="newsletter-wrap">
      <div className="newsletter">
        <div className="newsletter-left">
          <h3 className="newsletter-title">{t('newsletter.title')}</h3>
          <p className="newsletter-text">{t('newsletter.text')}</p>
        </div>
        <div className="newsletter-right">
          <div className="newsletter-eyebrow">{t('newsletter.eyebrow')}</div>
          <form className="newsletter-form" onSubmit={handleSubmit} noValidate>
            <input
              className="newsletter-input"
              type="email"
              placeholder={t('newsletter.placeholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="newsletter-btn" type="submit" disabled={submitting}>
              {submitting ? t('newsletter.sending') : t('newsletter.subscribe')}
            </button>
          </form>
          <p className="newsletter-fineprint">
            {t('newsletter.agree')}{' '}
            <a href="/terms" className="newsletter-link">{t('newsletter.terms')}</a>
          </p>
        </div>
      </div>
    </section>
  );
}
